/* eslint-disable react/no-did-update-set-state */
import React, { Fragment } from 'react';

import { FormControl } from 'react-bootstrap';
import styled from 'styled-components';

import '../../styles/containers/Orders.css';
import '../../styles/containers/Party.css';
import DatePicker from '../utils/FormWidgets/DatePicker';
import { FilterPanel } from '../utils/FilterPanel';
import Error from '../stateMessage/Error';
import CSVLinkButton from '../utils/CSVLinkButton';
import { ORDERS_CSV_HEADERS } from '../../infrastructure/constants/orders';
import {
  StyledFilterFormGroup,
  StyledFilterTitle,
  StyledFilterWrapper,
} from '../utils/Styles/FilterStyles';

const filteredDataInitial = {
  status: 'Pending',
  fromDate: '',
  toDate: '',
  name: '',
};

class State {
  filteredData = filteredDataInitial;
  isSuccsess = false;
  isError = false;
  isDeactive = false;
}

const StyledDateFields = styled(StyledFilterFormGroup)`
  &&& {
    padding-left: 0px;
    width: 175px;
    display: inline-block;
    vertical-align: top;
    margin-right: 25px;
  }
`;

const StyledDateFieldsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 10px 10px 0;

  p {
    margin: 0;
    margin-top: 10px;
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 20px;
    p {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
`;

const StyledClearButton = styled.button`
  margin-top: -7px;
  margin-left: 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

const StyledTextFieldWrapper = styled(StyledFilterFormGroup)`
  &&& {
    margin-bottom: 0;
  }
`;

export default class FilterOrderForm extends React.Component {
  filters = [
    { label: 'All Statuses', name: 'all' },
    { label: 'Cancelled', name: 'Cancelled' },
    { label: 'Confirmed', name: 'Confirmed' },
    { label: 'Fulfilled', name: 'Fulfilled' },
    { label: 'Pending', name: 'Pending' },
    { label: 'Refunded', name: 'Refunded' },
    { label: 'Abandoned', name: 'Abandoned' },
    { label: 'Payment Failure', name: 'PaymentFailure' },
  ];
  state = new State();

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  hideMessage = () => {
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isError: false });
    }
  };

  handleStatusChange = filter => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      status: filter !== 'all' ? filter : '',
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  handleDateChange = (name, date) => {
    const { filteredData } = this.state;
    const updatedData = { ...filteredData };
    updatedData[name] = date;
    this.setState({ filteredData: updatedData });
    this.handleSubmit(updatedData);
  };

  onFilterInputFieldChange = (key, value) => {
    const { filteredData } = this.state;
    const updated = {
      ...filteredData,
      [key]: value,
    };
    this.setState({ filteredData: updated });
    if (value.length >= 3 || value.length === 0) {
      this.handleSubmit(updated);
    }
  };

  handleSubmit = async filteredData => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterOrder } = this.props;
    filterOrder(filteredData);
  };

  clear = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { clear } = this.props;
    this.setState(prevState => {
      const filteredData = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.filteredData,
        toDate: '',
        fromDate: '',
        status: '',
        name: '',
      };
      return { filteredData };
    });
    clear();
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { isMobileFilterSelected, csvOrders, loadCSVOrders } = this.props;
    const { filteredData, isError } = this.state;
    return (
      <Fragment>
        <div
          className={`orders-filter form-content horizontal-form filter-form ${
            isMobileFilterSelected ? 'mobile-filter-selected' : ''
          }`}
          style={{ paddingLeft: '0px' }}
        >
          <StyledFilterTitle>Filters</StyledFilterTitle>
          <StyledFilterWrapper>
            <div className='orders-top-panel-wrapper'>
              <FilterPanel
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                filters={this.filters}
                currentFilter={
                  filteredData.status !== '' ? filteredData.status : 'all'
                }
                onFilterChange={this.handleStatusChange}
              />
              <StyledTextFieldWrapper>
                <FormControl
                  type='text'
                  placeholder='Name (3 characters min)'
                  onChange={e =>
                    this.onFilterInputFieldChange('name', e.target.value)
                  }
                  value={filteredData.name}
                />
              </StyledTextFieldWrapper>
            </div>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <CSVLinkButton
                data={[
                  {
                    id: 1,
                    items: csvOrders,
                    headers: ORDERS_CSV_HEADERS,
                    fileName: 'orders.csv',
                  },
                ]}
                filterData={filteredData}
                style={{ margin: 0, marginTop: '30px' }}
                loadData={loadCSVOrders}
              />
            }
          </StyledFilterWrapper>
          <StyledFilterWrapper>
            <StyledDateFieldsWrapper>
              <p>Event Dates:</p>
              <StyledDateFields controlId='fromDate'>
                <DatePicker
                  label='From'
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  value={filteredData.startDateTime}
                  handleChange={value =>
                    this.handleDateChange('startDateTime', value)
                  }
                />
              </StyledDateFields>
              <StyledDateFields controlId='toDate'>
                <DatePicker
                  label='To'
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  value={filteredData.endDateTime}
                  handleChange={value =>
                    this.handleDateChange('endDateTime', value)
                  }
                />
              </StyledDateFields>
            </StyledDateFieldsWrapper>
            <StyledDateFieldsWrapper>
              <p>Order Placed:</p>
              <StyledDateFields controlId='fromDate'>
                <DatePicker
                  label='From'
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  value={filteredData.fromDate}
                  handleChange={value =>
                    this.handleDateChange('fromDate', value)
                  }
                />
              </StyledDateFields>
              <StyledDateFields controlId='toDate'>
                <DatePicker
                  label='To'
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  value={filteredData.toDate}
                  handleChange={value => this.handleDateChange('toDate', value)}
                />
              </StyledDateFields>
            </StyledDateFieldsWrapper>
          </StyledFilterWrapper>
          <StyledDateFieldsWrapper>
            <StyledClearButton
              type='button'
              onClick={this.clear}
              className='btn btn-def panel-button'
            >
              Clear all
            </StyledClearButton>
          </StyledDateFieldsWrapper>
          {isError && <Error text='server error' />}
        </div>
      </Fragment>
    );
  }
}
